<template>
    <div class="user-product-select">
        <v-select type="select" v-model="selectedProducts" :off-icon="'far fa-square'" :items="products" attach chips label="Products" multiple></v-select>
        <input type="hidden" :value="checkedProducts" name="products">
    </div>
</template>

<script>
    export default {
        props : ['products', 'preSelectedProducts'],
        data : function(){
            return {
                selectedProducts : []
            }
        },
        mounted() {
            this.selectedProducts = this.preSelectedProducts.slice();
        },
        computed : {
            checkedProducts : function(){
                return this.selectedProducts.join(',');
            }
        }
    }
</script>
